import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <img
              src="/images/logos/targetsoftware-white.png"
              alt="Target Software"
              className="h-8 w-auto mb-4"
            />
            <p className="text-gray-400 mb-6">
              Mais de 23 anos transformando negócios através de soluções tecnológicas inovadoras.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.linkedin.com/company/targetsoftware/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#7d2128] transition-colors duration-200 cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="https://www.instagram.com/target_software/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#7d2128] transition-colors duration-200 cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a href="https://www.facebook.com/TargetSoftware" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-[#7d2128] transition-colors duration-200 cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Produtos</h3>
            <ul className="space-y-2">
              <li><a href="/produtos/target-incentivos" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">Target Incentivos</a></li>
              <li><a href="/produtos/target-partnership" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">Target Partnership</a></li>
              <li><a href="/produtos/target-sales" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">Target Sales</a></li>
              <li><a href="/produtos/inteligencia-dados" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">Inteligência de Dados</a></li>              
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Tecnologia</h3>
            <ul className="space-y-2">
              <li><a href="/cases" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">Cases</a></li>              
              <li><a href="/produtos/fabrica-software" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">Fábrica de Software</a></li>
              <li><a href="/produtos/outsourcing" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">Outsourcing</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Empresa</h3>
            <ul className="space-y-2">
              <li><a href="/contato" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">Contato</a></li>
              <li><a href="https://www.linkedin.com/company/targetsoftware/jobs/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">Trabalhe Conosco</a></li>
              <li><a href="/politica-privacidade" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">Política de Privacidade</a></li>
              <li><a href="/outras-politicas" className="text-gray-400 hover:text-white transition-colors duration-200 cursor-pointer">Outras Políticas</a></li>              
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">© 2025 Target Software. Todos os direitos reservados.</p>            
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;